enum Gender {
    Male = 1,
    Female = 2,
}

enum BuildType {
    Preferred = 'preferred',
    LivingPromise = 'living promise',
    EasySoluion = 'easy solution',
}

enum RatingClass {
    Tobacco = 'tobacco',
    NonTobacco = 'non-tobacco',
}

enum BuildFilter {
    GT_ES = '> Easy Solution',
    GT_LP_LTE_SE = '> Living Promise, <= Easy Solution',
    GT_P_LTE_LP = '> Preferred, <= Living Promise',
    LTE_P = '<= Preferred',
    LTE_LP = '<= Living Promise',
    GT_LP = '> Living Promise',
}

const IncomeRanges = [29999, 49999, 99999, 249999, 250000];

enum State {
    Alaska = 1,
    Alabama = 2,
    Arkansas = 3,
    Arizona = 4,
    California = 5,
    Colorado = 6,
    Connecticut = 7,
    'Dist of Columbia' = 8,
    Delaware = 9,
    Florida = 10,
    Georgia = 11,
    Hawaii = 12,
    Iowa = 13,
    Idaho = 14,
    Illinois = 15,
    Indiana = 16,
    Kansas = 17,
    Kentucky = 18,
    Louisiana = 19,
    Massachusetts = 20,
    Maryland = 21,
    Maine = 22,
    Michigan = 23,
    Minnesota = 24,
    Missouri = 25,
    Mississippi = 26,
    Montana = 27,
    'North Carolina' = 28,
    'North Dakota' = 29,
    Nebraska = 30,
    'New Hampshire' = 31,
    'New Jersey' = 32,
    'New Mexico' = 33,
    'Nevada' = 34,
    'New York' = 35,
    Ohio = 36,
    Oklahoma = 37,
    Oregon = 38,
    Pennsylvania = 39,
    'Puerto Rico' = 40,
    'Rhode Island' = 41,
    'South Carolina' = 42,
    'South Dakota' = 43,
    Tennessee = 44,
    Texas = 45,
    Utah = 46,
    Virginia = 47,
    Vermont = 48,
    Washington = 49,
    Wisconsin = 50,
    'West Virginia' = 51,
    Wyoming = 52,
}

enum SmokingProducts {
    Cigarettes = 'Cigarettes',
    Marijuana = 'Marijuana',
    Others = 'Others',
}

const SmokingFrequency = {
    1: 'Atmostonceamonth',
    2: 'Onceaweek',
    3: '_2timesaweek',
    4: '_4timesaweek',
};

export {Gender, BuildType, RatingClass, BuildFilter, IncomeRanges, State, SmokingProducts, SmokingFrequency};
